import React, { useState } from 'react'
import {
  Row,
  Col,
  NavbarToggler as NavbarTogglerBase,
  NavLink as NavLinkBase,
  UncontrolledDropdown,
  DropdownToggle as DropdownToggleBase,
  DropdownMenu as DropdownMenuBase,
  Button,
  Input
} from 'reactstrap'
import styled from 'styled-components'
import Modal from 'ui/modal'
import ContactForm from 'containers/layouts/contact_form'
import { useTranslation } from 'react-i18next'
import { get } from 'lodash'
import goforajourneyLogoWhite from 'goforajourney/img/goforajourney-logo-white-h'

const ContactLink = () => {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)
  const { i18n } = useTranslation()

  return (
    <>
      <a className="text-light" onClick={toggle} style={{ cursor: 'pointer' }}>
        Contact
      </a>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        header={i18n.t('navbar.contact_link.modal_title')}
      >
        <ContactForm />
      </Modal>
    </>
  )
}

const FooterSection = styled.div.attrs({
  className: ''
})`
  max-width: 280px;
  font-size: 0.95em;
  font-weight: 500;
  letter-spacing: normal;
  line-height: 30px;
  color: rgb(255 255 255 / 75%);
`

const Footer = (props) => {
  const { menu_props, user } = props
  const { root, footer_links, destination_link } = menu_props
  const { privacy, terms_and_conditions, merchant_terms_and_conditions } = footer_links
  const destinations =
    get(user, 'user_data.user.destinations') ||
    get(user, 'user.destinations') ||
    []

  return (
    <div className="text-white mt-5 py-3 pb-3 pb-md-0" style={{ background: '#363636' }}>
      <div className="container py-4">
        <Row>
          <Col className="d-flex justify-content-center justify-content-md-start">
            <a href={root}>
              <img src={goforajourneyLogoWhite} alt="GoForAJourney Logo" />
            </a>
          </Col>
        </Row>

        <Row className="py-4">
          {/* CONTACT */}
          <Col
            xs="12"
            sm="6"
            md="3"
            className="d-flex flex-column align-items-start mb-5 mb-md-0 px-5 px-md-0"
          >
            <h3 className="mb-4">Get In Touch</h3>
            <FooterSection>
              <p>Have any questions? Feel free to call us or drop us an email.</p>
              <div>
                <i className="fa fa-envelope me-2" style={{ opacity: '100', color: '#FFF' }} />
                <a className="text-light" href="mailto:contact@goforajourney.com">
                  contact@goforajourney.com
                </a>
              </div>
              <div className="mt-3">
                <i className="fa fa-phone me-2" style={{ opacity: '100', color: '#FFF' }} />
                <a className="text-light" href="tel:+17866173997">
                  +1 (786) 617 3997
                </a>
              </div>
            </FooterSection>
          </Col>

          {/* ABOUT */}
          <Col
            xs="12"
            sm="6"
            md="3"
            className="d-flex flex-column align-items-start mb-5 mb-md-0 px-5 px-md-0"
          >
            <h3 className="mb-4">About</h3>
            <FooterSection>
              <ul className="list-unstyled m-0 p-0">
                <li>
                  <a className="text-light" href={root}>
                    Home
                  </a>
                </li>
                {destinations.map(({ slug, name }) => {
                  let url = destination_link.replace(/ *\:[^)]*\: */g, slug)
                  if (slug == "drawing-experience") {
                    url = 'https://gfabfac.palisis.com/'
                  }

                  return (
                    <li key={slug}>
                      <a
                        className="text-light"
                        href={url}
                      >
                        {name}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </FooterSection>
          </Col>

          {/* SUPPORT */}
          <Col
            xs="12"
            sm="6"
            md="3"
            className="d-flex flex-column align-items-start mb-5 mb-md-0 px-5 px-md-0"
          >
            <h3 className="mb-4">Support</h3>
            <FooterSection>
              <ul className="list-unstyled m-0 p-0">
                <li>
                  <a className="text-light" href={terms_and_conditions.link}>
                    {terms_and_conditions.label}
                  </a>
                </li>
                <li>
                  <a
                    className="text-light"
                    href={merchant_terms_and_conditions.link}
                  >
                    {merchant_terms_and_conditions.label}
                  </a>
                </li>
                <li>
                  <a className="text-light" href={privacy.link}>
                    {privacy.label}
                  </a>
                </li>
                <li>
                  <ContactLink />
                </li>
              </ul>
            </FooterSection>
          </Col>

          {/* NEWSLETTER */}
          <Col
            xs="12"
            sm="6"
            md="3"
            className="d-flex flex-column align-items-center align-items-md-start text-center"
          >
            <h3 className="mb-4">Our Newsletter</h3>
            <FooterSection>
              <p>
                Sign up to our Newsletter for all the latest updates and experiences:
                (Coming soon)
              </p>
              <Input
                className="newsletter-input my-3 p-4"
                placeholder="Email"
                style={{
                  color: '#FFF',
                  borderRadius: '50px',
                  borderColor: 'transparent',
                  background: '#6B6B6B',
                  fontWeight: '500'
                }}
              />
              <Button disabled size="lg" color="primary" className="w-100 p-3">
                Subscribe
              </Button>
            </FooterSection>
          </Col>
        </Row>
      </div>

      <div className="mx-5" style={{ borderTop: '1px solid #666', height: '5px' }} />

      <div className="container px-0 py-2 fw-bold d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div style={{ fontWeight: 500 }}>© Gofora LLC – All rights reserved</div>
        <ul
          className="d-flex py-2 list-unstyled align-items-center align-self-center"
          style={{ fontSize: '1.2em' }}
        >
          <li className="px-2">
            <a
              href="https://www.facebook.com/people/Goforajourney/61557744644591/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <i className="text-white fab fa-facebook" />
            </a>
          </li>
          <li className="px-2">
            <a
              href="https://www.instagram.com/goforajourney_tours"
              target="_blank"
              rel="noreferrer noopener"
            >
              <i className="text-white fab fa-instagram" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Footer
